export default __webpack_public_path__ + "static/banner-web-application-development-b295fcd441cba410c8d5b666f4388779.jpg";